import { useEffect, useRef } from "react";
import { toast } from "sonner";
import {
    shouldShowReleaseNotes,
    markReleaseNotesSeen,
    RELEASE_NOTES_LINE,
} from "@/lib/releaseNotes";

// Fires ONCE per device (per release-version) on the next visit after a
// meaningful update. Gated on:
//   - settings loaded (= signed in + bootstrap complete; never fires at the
//     auth gate)
//   - no overlay currently open (morning check-in, milestone, overwhelm,
//     cover-offer, waited-for-you intro) so this lands cleanly on its own
//   - haven't already seen this release's line (localStorage flag)
// `firedRef` ensures we never fire twice in the same session even if
// dependencies oscillate.
export function useReleaseNotes({ settings, anyOverlayOpen }) {
    const firedRef = useRef(false);

    useEffect(() => {
        if (firedRef.current) return;
        if (!settings) return;
        if (anyOverlayOpen) return;
        if (!shouldShowReleaseNotes()) return;

        firedRef.current = true;
        // Small delay so the toast doesn't race with whatever just dismissed
        // (e.g. user skipped morning check-in → toast lands 1.5s later, not
        // immediately on top of the dismiss animation).
        const t = setTimeout(() => {
            toast(RELEASE_NOTES_LINE, { duration: 8000 });
            markReleaseNotesSeen();
        }, 1500);
        return () => clearTimeout(t);
    }, [settings, anyOverlayOpen]);
}
